import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css'
import Link from '../../common/Link'
import { trackEventLog } from '../../../core/utils'

// 因为导航个数是动态的，然后有可能多有可能少
// 手动指定这个个数作为展示出来的导航个数，多余的收起
// 13这个神奇的数字是试出来的，没想到其他办法怎么实现了，和产品沟通的结果
const COUNT = 13


class Navigation extends React.Component {

  static propTypes = {
    tags: PropTypes.array.isRequired,
  }

  render() {
    const { tags } = this.props
    return (
      <div className={s.root}>
        <div className={s.inner}>
          {tags.slice(0, COUNT).map(tag => (
            <div key={`home-nav-${tag.id}`} className={s.tagEntry}>
              <Link
                className={s.navItem}
                onClick={() => { trackEventLog(`w/index/tag/${tag.id}`) }}
                // 如果有url优先url
                to={tag.url ? tag.url : `/tag/${tag.id}`}
                extraParams={{ ptag: tag.id }}
              >{tag.title}</Link>
              <span className={s.hover} />
              {tag.tag && tag.tag.subTag && tag.tag.subTag.length !== 0 ?
                <div className={s.pannel}>
                  {tag.tag.subTag.map(subTag =>
                  (<Link
                    key={`home-nav-sub-${subTag.id}`}
                    // 如果有url优先url
                    to={subTag.url ? subTag.url : `/tag/${subTag.id}`}
                    extraParams={{ ptag: tag.id }}
                    onClick={() => { trackEventLog(`w/index/tag/${subTag.id}`) }}
                  >{subTag.name}</Link>))}
                </div> : null}
            </div>),
          )}
          {tags.length > COUNT ?
            <div className={s.tagEntry}>
              <span className={s.navItem}><span className={s.more} /></span>
              <div className={s.pannel}>
                {tags.slice(COUNT).map(tag => (
                  <Link
                    key={`home-nav-more-${tag.id}`}
                    onClick={() => { trackEventLog(`w/index/tag/${tag.id}`) }}
                    // 如果有url优先url
                    to={tag.url ? tag.url : `/tag/${tag.id}`}
                  >{tag.title}</Link>))}
              </div>
            </div> : null
          }
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Navigation);



// WEBPACK FOOTER //
// ./src/components/p_home/Nav/index.js